/**
 * mSTEM Robot Block Info Modal container (DR-05 / ROB-02..04).
 * Reads which composite the student inspected from
 * state.scratchGui.modals.robotBlockInfoKey (set by the affordance wired
 * in 04-04) and dispatches closeRobotBlockInfo on the "Đã hiểu" action.
 *
 * Mirrors the robot-manager-modal container pattern:
 * compose(injectIntl, connect(...)) over a pure presentational component.
 */
import {connect} from 'react-redux';
import {compose} from 'redux';
import {injectIntl} from 'react-intl';

import {closeRobotBlockInfo, setRobotBlockInfoKey} from '../reducers/modals';

import RobotBlockInfoModalComponent from '../components/robot-block-info-modal/robot-block-info-modal.jsx';

const mapStateToProps = state => ({
    compositeKey: state.scratchGui.modals.robotBlockInfoKey || 'lineFollow'
});

const mapDispatchToProps = dispatch => ({
    onRequestClose: () => dispatch(closeRobotBlockInfo()),
    // Phase 4 gap-closure: the in-modal composite selector lets the student
    // switch between the 3 "what's inside" diagrams (ROB-02/03/04).
    onSelectComposite: key => dispatch(setRobotBlockInfoKey(key))
});

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(RobotBlockInfoModalComponent);
